import { render, staticRenderFns } from "./ItemsRentList.vue?vue&type=template&id=be8ae8f4&scoped=true&"
import script from "./ItemsRentList.vue?vue&type=script&lang=js&"
export * from "./ItemsRentList.vue?vue&type=script&lang=js&"
import style0 from "./ItemsRentList.vue?vue&type=style&index=0&id=be8ae8f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8ae8f4",
  null
  
)

export default component.exports